import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, authApi } from "@/api";

const AuthContext = createContext(null);
const TOKEN_KEY = "erp_token";

export const isAdminRole = (u) => u && ["superadmin", "admin"].includes(u.role);
export const canModule = (u, m) => !!u && (isAdminRole(u) || (u.modules || []).includes(m));

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  }, []);

  useEffect(() => {
    const id = api.interceptors.response.use((r) => r, (err) => {
      if (err?.response?.status === 401) logout();
      return Promise.reject(err);
    });
    return () => api.interceptors.response.eject(id);
  }, [logout]);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) { setUser(false); return; }
    authApi.me().then(setUser).catch(() => logout());
  }, [logout]);

  const login = async (username, password) => {
    const { token, user: u } = await authApi.login(username, password);
    localStorage.setItem(TOKEN_KEY, token);
    setUser(u);
    return u;
  };

  return <AuthContext.Provider value={{ user, login, logout, refresh: () => authApi.me().then(setUser) }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
